import { Wifi, WifiLow, WifiZero } from "lucide-react";
import type { QualitySeverity } from "../../room/connection-quality";

// eslint-disable-next-line react-refresh/only-export-components -- Shared severity colors intentionally accompany the icon; edits may reload importers.
export const qualityColor = {
  info: "text-muted-foreground",
  good: "text-quality-good",
  warning: "text-quality-warning",
  critical: "text-quality-critical",
};

export function QualityIcon({
  severity,
  className = "size-4.5",
}: {
  severity: QualitySeverity;
  className?: string;
}) {
  const Foreground = severity === "critical" ? WifiZero : severity === "good" ? Wifi : WifiLow;
  return (
    <span className={`relative grid shrink-0 place-items-center ${className}`} aria-hidden="true">
      <Wifi className="absolute size-full opacity-20" />
      <Foreground className="absolute z-1 size-full" />
    </span>
  );
}
